const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: 'Layout',
	DefaultRenderable: 'Layout-Display',
	CSS: /*css*/`
		/* html/body/container styles owned by the Shell view; Layout just
		   shapes its own pane inside #ClaudeTransformer-Workspace. */
		#ClaudeTransformer-Workspace { display: flex; flex-direction: column; height: 100%; }
		.cst-app { display: flex; flex-direction: column; flex: 1 1 auto; min-height: 0; }
		.cst-header
		{
			display: flex; flex-direction: column; gap: 8px;
			padding: 10px 18px; border-bottom: 1px solid var(--theme-color-border-light, #e3e6ee);
			background: var(--theme-color-background-secondary, #f6f8fb);
			flex: 0 0 auto;
		}
		.cst-header-top { display: flex; align-items: center; gap: 14px; }
		.cst-header-title-block { flex: 1 1 auto; min-width: 0; }
		.cst-header-title { font-size: 17px; font-weight: 600; line-height: 1.25; }
		.cst-header-subtitle { color: var(--theme-color-text-secondary, #5b6376); font-size: 12px; margin-top: 2px; display: flex; gap: 10px; flex-wrap: wrap; }
		.cst-header-cards { display: flex; align-items: stretch; gap: 10px; flex-wrap: wrap; }
		.cst-stat-card
		{
			background: var(--theme-color-background-panel, #fff);
			border: 1px solid var(--theme-color-border-default, #dde2ee);
			border-radius: 6px;
			padding: 8px 12px;
			min-width: 160px;
			flex: 0 1 auto;
		}
		.cst-stat-card h4
		{
			margin: 0 0 4px 0;
			font-size: 10px;
			text-transform: uppercase;
			letter-spacing: 0.05em;
			color: var(--theme-color-text-secondary, #5b6376);
			font-weight: 600;
		}
		.cst-stat-card ul
		{
			list-style: none;
			margin: 0;
			padding: 0;
			font-size: 12px;
			color: var(--theme-color-text-secondary, #4a5066);
			line-height: 1.55;
		}
		.cst-stat-card li { display: flex; align-items: center; gap: 4px; }
		.cst-stat-card-time strong { color: var(--theme-color-text-primary, #1d2230); font-weight: 600; }
		.cst-metric { cursor: help; border-bottom: 1px dotted transparent; transition: border-bottom-color 0.1s, color 0.1s; }
		.cst-metric:hover { color: var(--theme-color-text-primary, #1d2230); border-bottom-color: var(--theme-color-text-secondary, #5b6376); }
		.cst-stat-card-time .cst-metric { width: 100%; }
		.cst-metric-help
		{
			display: inline-flex; align-items: center; justify-content: center;
			width: 16px; height: 16px;
			margin-left: 4px;
			border-radius: 50%;
			background: var(--theme-color-border-light, #e3e6ee); color: var(--theme-color-text-secondary, #5b6376);
			font-size: 11px; font-style: normal;
			cursor: pointer;
			transition: background 0.1s, color 0.1s;
			vertical-align: middle;
		}
		.cst-metric-help:hover { background: var(--theme-color-brand-primary, #4a7ad6); color: var(--theme-color-background-panel, #fff); }
		.cst-metric-key dl { margin: 0; }
		.cst-metric-key dt { font-weight: 600; color: var(--theme-color-text-primary, #1d2230); margin-top: 12px; }
		.cst-metric-key dt:first-child { margin-top: 0; }
		.cst-metric-key dd { margin: 4px 0 0 0; color: var(--theme-color-text-secondary, #4a5066); line-height: 1.5; }
		.cst-metric-key code { background: var(--theme-color-background-tertiary, #eef0f5); padding: 1px 5px; border-radius: 3px; font-size: 12px; }
		.cst-metric-key .cst-metric-key-eq { color: var(--theme-color-text-secondary, #5b6376); font-style: italic; font-size: 12px; }
		.cst-stat-card-visibility li { gap: 6px; }
		.cst-stat-card-visibility li label
		{
			display: flex; align-items: center; gap: 6px;
			cursor: pointer; user-select: none;
			width: 100%;
		}
		.cst-stat-card-visibility input[type=checkbox] { margin-left: auto; cursor: pointer; }
		.cst-color-dot
		{
			display: inline-block;
			width: 10px; height: 10px;
			border-radius: 2px;
			flex: 0 0 auto;
		}
		.cst-color-dot-chatter     { background: var(--theme-color-brand-primary, #4a7ad6); }
		.cst-color-dot-attachments { background: var(--theme-color-status-warning, #c8a93a); }
		.cst-color-dot-tools       { background: var(--theme-color-brand-accent, #b07acc); }
		.cst-header-actions { display: flex; gap: 6px; align-self: flex-start; }
		.cst-action-btn
		{
			padding: 6px 12px; border: 1px solid var(--theme-color-border-default, #b0b6c2); background: var(--theme-color-background-panel, #fff);
			border-radius: 6px; cursor: pointer; font-size: 13px;
		}
		.cst-action-btn:hover { background: var(--theme-color-background-hover, #eaf2ff); }

		.cst-signature-bar { padding: 8px 18px 14px 18px; border-bottom: 1px solid var(--theme-color-border-light, #e3e6ee); background: var(--theme-color-background-secondary, #f6f8fb); flex: 0 0 auto; max-height: 30vh; overflow: hidden; display: flex; flex-direction: column; }

		.cst-body { display: flex; flex: 1 1 auto; min-height: 0; }
		.cst-rail
		{
			flex: 0 0 240px;
			border-right: 1px solid var(--theme-color-border-light, #e3e6ee);
			overflow-y: auto;
			background: var(--theme-color-background-secondary, #fafbfd);
		}
		.cst-main { flex: 1 1 auto; overflow-y: auto; padding: 16px 24px; min-width: 0; }
		.cst-detail
		{
			flex: 0 0 380px;
			border-left: 1px solid var(--theme-color-border-light, #e3e6ee);
			overflow-y: auto;
			background: var(--theme-color-background-secondary, #fafbfd);
			display: none;
		}
		.cst-detail.cst-detail-open { display: block; }

		@media print
		{
			.cst-header-actions, .cst-rail, .cst-detail, .cst-signature-bar, .cst-dropzone-container { display: none !important; }
			.cst-main { overflow: visible; padding: 0; }
			.cst-app  { height: auto; }
		}
	`,
	Templates:
	[
		{
			Hash: 'Layout-Display',
			Template: /*html*/`
<div class="cst-app">
	<div class="cst-header">
		<div class="cst-header-top">
			<div class="cst-header-title-block">
				<div class="cst-header-title">{~D:AppData.Session.Meta.title~}</div>
				<div class="cst-header-subtitle">
					<span>{~D:AppData.Session.Meta.sessionId~}</span>
					<span>· {~D:AppData.Session.Meta.model~}</span>
				</div>
			</div>
			<div class="cst-header-actions">
				<button class="cst-action-btn" onclick="_Pict.views.Layout.exportMarkdown()">Markdown</button>
				<button class="cst-action-btn" onclick="_Pict.views.Layout.exportPDF()">Print / PDF</button>
				<button class="cst-action-btn" onclick="_Pict.views.Layout.reset()">Load another</button>
			</div>
		</div>
		<div class="cst-header-cards">
			<div class="cst-stat-card cst-stat-card-counts">
				<h4>Session</h4>
				<ul>
					<li>· {~D:AppData.Layout.PromptCountLabel~}</li>
					<li>· {~D:AppData.Layout.ToolCountLabel~}</li>
					<li>· {~D:AppData.Layout.AgentCountLabel~}</li>
				</ul>
			</div>
			<div class="cst-stat-card cst-stat-card-time">
				<h4>Time
					<span class="cst-metric-help" onclick="_Pict.views.Layout.showMetricsKey()" title="What do these mean?">ⓘ</span>
				</h4>
				<ul>
					<li><span class="cst-metric" onclick="_Pict.views.Layout.showMetricsKey('total')">· <strong>{~D:AppData.Layout.DurationLabel~}</strong> total</span></li>
					<li><span class="cst-metric" onclick="_Pict.views.Layout.showMetricsKey('engaged')">· <strong>{~D:AppData.Layout.EngagedLabel~}</strong> engaged</span></li>
					<li><span class="cst-metric" onclick="_Pict.views.Layout.showMetricsKey('standby')">· {~D:AppData.Layout.IdleLabel~} standby</span></li>
					<li><span class="cst-metric" onclick="_Pict.views.Layout.showMetricsKey('claude')">· Claude working {~D:AppData.Layout.ClaudeWorkingLabel~}</span></li>
					<li><span class="cst-metric" onclick="_Pict.views.Layout.showMetricsKey('user')">· you working {~D:AppData.Layout.UserWorkingLabel~}</span></li>
				</ul>
			</div>
			<div class="cst-stat-card cst-stat-card-visibility">
				<h4>Visible</h4>
				<ul>
					<li><label>
						<span class="cst-color-dot cst-color-dot-chatter"></span>
						<span>{~D:AppData.Layout.ChatterCountLabel~}</span>
						<input type="checkbox" id="cst-toggle-chatter" {~D:AppData.Layout.ChatterCheckedAttr~}
							onchange="_Pict.views.Layout.toggleIntermediaries()" />
					</label></li>
					<li><label>
						<span class="cst-color-dot cst-color-dot-attachments"></span>
						<span>{~D:AppData.Layout.AttachmentCountLabel~}</span>
						<input type="checkbox" id="cst-toggle-attachments" {~D:AppData.Layout.AttachmentsCheckedAttr~}
							onchange="_Pict.views.Layout.toggleAttachments()" />
					</label></li>
					<li><label>
						<span class="cst-color-dot cst-color-dot-tools"></span>
						<span>{~D:AppData.Layout.ToolCountForVisibilityLabel~}</span>
						<input type="checkbox" id="cst-toggle-tools" {~D:AppData.Layout.ToolsCheckedAttr~}
							onchange="_Pict.views.Layout.toggleTools()" />
					</label></li>
				</ul>
			</div>
		</div>
	</div>
	<div class="cst-signature-bar" id="Signature-Container"></div>
	<div class="cst-body">
		<div class="cst-rail" id="Timeline-Container"></div>
		<div class="cst-main" id="Conversation-Container"></div>
		<div class="cst-detail{~NE:AppData.Layout.DetailOpen^ cst-detail-open~}" id="Detail-Container"></div>
	</div>
</div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'Layout-Display',
			TemplateHash:   'Layout-Display',
			ContentDestinationAddress: '#ClaudeTransformer-Workspace'
		}
	]
};

class PictViewLayout extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.pict.AppData.Layout = this.pict.AppData.Layout ||
		{
			DetailOpen: false,
			ShowAttachments: false,
			ShowTools: true,
			ShowIntermediaries: true,
			DurationLabel: '',
			IdleLabel: '',
			EngagedLabel: '',
			ClaudeWorkingLabel: '',
			UserWorkingLabel: '',
			PromptCountLabel: '',
			ToolCountLabel: '',
			AgentCountLabel: '',
			ChatterCountLabel: '',
			AttachmentCountLabel: '',
			ToolCountForVisibilityLabel: '',
			ChatterCheckedAttr: '',
			AttachmentsCheckedAttr: '',
			ToolsCheckedAttr: ''
		};
	}

	updateLabels()
	{
		let tmpStats = (this.pict.AppData.Session && this.pict.AppData.Session.Stats) || {};
		let tmpL = this.pict.AppData.Layout;
		tmpL.DurationLabel = formatDuration(tmpStats.totalDurationMs);
		tmpL.IdleLabel = formatDuration(tmpStats.standbyMs != null ? tmpStats.standbyMs : tmpStats.idleMs);
		tmpL.EngagedLabel = formatDuration(tmpStats.engagedMs != null ? tmpStats.engagedMs : tmpStats.activeMs);
		tmpL.ClaudeWorkingLabel = formatDuration(tmpStats.claudeWorkingMs || 0);
		tmpL.UserWorkingLabel = formatDuration(tmpStats.userWorkingMs || 0);
		tmpL.PromptCountLabel = (tmpStats.promptCount || 0) + ' prompts';
		tmpL.ToolCountLabel = (tmpStats.toolCallCount || 0) + ' tool calls';
		tmpL.AgentCountLabel = (tmpStats.agentCount || 0) + ' subagents';
		tmpL.ChatterCountLabel = (tmpStats.chatterCount || 0) + ' chatter';
		tmpL.AttachmentCountLabel = (tmpStats.attachmentItemCount || 0) + ' attachments';
		tmpL.ToolCountForVisibilityLabel = (tmpStats.toolCallCount || 0) + ' tools';
		tmpL.ChatterCheckedAttr     = tmpL.ShowIntermediaries ? 'checked' : '';
		tmpL.AttachmentsCheckedAttr = tmpL.ShowAttachments    ? 'checked' : '';
		tmpL.ToolsCheckedAttr       = tmpL.ShowTools          ? 'checked' : '';
	}

	toggleIntermediaries()
	{
		this.pict.AppData.Layout.ShowIntermediaries = !this.pict.AppData.Layout.ShowIntermediaries;
		this._afterToggle();
	}

	toggleAttachments()
	{
		this.pict.AppData.Layout.ShowAttachments = !this.pict.AppData.Layout.ShowAttachments;
		this._afterToggle();
	}

	toggleTools()
	{
		this.pict.AppData.Layout.ShowTools = !this.pict.AppData.Layout.ShowTools;
		this._afterToggle();
	}

	_afterToggle()
	{
		// Only the conversation pane needs to update: it reads the new ShowX state and rewrites
		// the visibility classes on its inner container. The browser has already updated the
		// checkbox itself (it was the click target), so Layout's DOM stays untouched — which
		// preserves any open detail pane and the signature/timeline/conversation contents.
		this.updateLabels();
		if (this.pict.views.Conversation) this.pict.views.Conversation.render();
	}

	showMetricsKey(pHighlightKey)
	{
		// pHighlightKey: optional 'total' | 'engaged' | 'standby' | 'claude' | 'user' — when supplied,
		// that row gets visually emphasized so clicking a specific metric jumps you to its definition.
		let tmpModal = this.pict.views.PictSectionModal;
		if (!tmpModal) return;

		let tmpStats = (this.pict.AppData.Session && this.pict.AppData.Session.Stats) || {};
		let tmpL = this.pict.AppData.Layout || {};

		let tmpEntries =
		[
			{
				Key: 'total',
				Term: 'Total',
				Value: tmpL.DurationLabel,
				Definition: 'Wall-clock time from the very first record in the session to the very last. Includes everything — Claude generating, tools running, you typing, you sleeping.'
			},
			{
				Key: 'engaged',
				Term: 'Engaged',
				Value: tmpL.EngagedLabel,
				Definition: 'Time something was actually happening. Equals <code>Total − Standby</code>. This is the sum of <strong>Claude working</strong> + <strong>you working</strong>.'
			},
			{
				Key: 'standby',
				Term: 'Standby',
				Value: tmpL.IdleLabel,
				Definition: 'Long idle gaps where neither you nor Claude was active — typically you walking away from the computer. Any pause longer than 5 minutes between turns counts as standby.'
			},
			{
				Key: 'claude',
				Term: 'Claude working',
				Value: tmpL.ClaudeWorkingLabel,
				Definition: 'Time the model was generating a response or a tool was executing. Computed as the sum of deltas leading into assistant turns and tool-result turns.'
			},
			{
				Key: 'user',
				Term: 'You working',
				Value: tmpL.UserWorkingLabel,
				Definition: 'Time you spent reading replies and composing the next prompt. Sum of deltas leading into your prompts, plus any short pauses (under 5 minutes) — those count as thinking/typing rather than standby.'
			}
		];

		let tmpHTML = '<div class="cst-metric-key"><dl>';
		for (let i = 0; i < tmpEntries.length; i++)
		{
			let tmpE = tmpEntries[i];
			let tmpHighlight = (tmpE.Key === pHighlightKey) ? ' style="background:var(--theme-color-background-hover, #fffae3);border-radius:4px;padding:6px 8px;margin-left:-8px;margin-right:-8px;"' : '';
			tmpHTML += '<div' + tmpHighlight + '>'
				+ '<dt>' + escapeHTML(tmpE.Term) + ' <span class="cst-metric-key-eq">— ' + escapeHTML(tmpE.Value || '0s') + '</span></dt>'
				+ '<dd>' + tmpE.Definition + '</dd>'
				+ '</div>';
		}
		tmpHTML += '</dl>'
			+ '<p style="margin-top:18px;color:var(--theme-color-text-secondary, #5b6376);font-size:12px;font-style:italic;">'
			+ 'By construction: <code>Claude working + you working + Standby = Total</code>.'
			+ '</p>'
			+ '</div>';

		tmpModal.show({
			title:   'Time metrics',
			content: tmpHTML,
			width:   '560px',
			buttons: [{ Hash: 'ok', Label: 'Got it', Style: 'primary' }]
		});
	}

	exportMarkdown()
	{
		let tmpExporter = this.pict.providers.SessionExporter;
		if (tmpExporter) tmpExporter.downloadMarkdown();
	}

	exportPDF()
	{
		let tmpExporter = this.pict.providers.SessionExporter;
		if (tmpExporter) tmpExporter.printPDF();
	}

	reset()
	{
		this.pict.AppData.Session = null;
		let tmpApp = this.pict.PictApplication;
		// Host back-out: plansheet returns to its Sessions list (the standalone
		// viewer went back to its dropzone here).
		if (tmpApp && typeof tmpApp.showSessions === 'function') tmpApp.showSessions();
	}

	openDetail(pTitle, pHTML)
	{
		// Manipulate the detail container directly instead of re-rendering the whole Layout —
		// otherwise the shell rebuild would wipe #Signature-Container / #Timeline-Container /
		// #Conversation-Container and the rest of the page goes blank until something else
		// triggers a render.
		this.pict.AppData.Layout.DetailOpen = true;
		this.pict.ContentAssignment.assignContent('#Detail-Container',
			'<div style="padding:14px 16px;border-bottom:1px solid var(--theme-color-border-light, #e3e6ee);display:flex;align-items:center;">'
			+ '<strong style="flex:1;">' + escapeHTML(pTitle) + '</strong>'
			+ '<button class="cst-action-btn" onclick="_Pict.views.Layout.closeDetail()">Close</button>'
			+ '</div>'
			+ '<div style="padding:14px 16px;">' + pHTML + '</div>');
		let tmpEl = document.getElementById('Detail-Container');
		if (tmpEl) tmpEl.classList.add('cst-detail-open');
	}

	closeDetail()
	{
		this.pict.AppData.Layout.DetailOpen = false;
		let tmpEl = document.getElementById('Detail-Container');
		if (tmpEl) tmpEl.classList.remove('cst-detail-open');
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		this._attachMetricTooltips();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	_attachMetricTooltips()
	{
		// Tooltips must be re-attached on every render — the metric spans are recreated when the
		// header template re-renders, so any previous tooltip handles point at dead DOM.
		let tmpModal = this.pict.views.PictSectionModal;
		if (!tmpModal || typeof tmpModal.tooltip !== 'function') return;

		// Tear down any tooltips we registered on the previous render.
		if (this._metricTooltipHandles)
		{
			for (let i = 0; i < this._metricTooltipHandles.length; i++)
			{
				try { this._metricTooltipHandles[i].destroy(); } catch (e) { /* ignore */ }
			}
		}
		this._metricTooltipHandles = [];

		let tmpTooltips =
		[
			{ Key: 'total',   Text: 'Wall-clock time from session start to end. Click for details.' },
			{ Key: 'engaged', Text: 'Total minus standby — time something was happening (Claude working + you working). Click for details.' },
			{ Key: 'standby', Text: 'Long idle gaps (≥ 5 min) where neither side was active. Click for details.' },
			{ Key: 'claude',  Text: 'Time the model was generating or a tool was running. Click for details.' },
			{ Key: 'user',    Text: 'Time you spent reading replies and composing the next prompt. Includes short pauses under 5 minutes. Click for details.' }
		];

		let tmpSpans = document.querySelectorAll('.cst-stat-card-time .cst-metric');
		for (let i = 0; i < Math.min(tmpSpans.length, tmpTooltips.length); i++)
		{
			let tmpHandle = tmpModal.tooltip(tmpSpans[i], tmpTooltips[i].Text, { position: 'bottom' });
			if (tmpHandle) this._metricTooltipHandles.push(tmpHandle);
		}
	}
}

function formatDuration(pMs)
{
	if (!pMs || pMs < 0) return '0s';
	let tmpS = Math.floor(pMs / 1000);
	if (tmpS < 60) return tmpS + 's';
	let tmpM = Math.floor(tmpS / 60);
	if (tmpM < 60) return tmpM + 'm ' + (tmpS % 60) + 's';
	let tmpH = Math.floor(tmpM / 60);
	if (tmpH < 24) return tmpH + 'h ' + (tmpM % 60) + 'm';
	let tmpD = Math.floor(tmpH / 24);
	return tmpD + 'd ' + (tmpH % 24) + 'h';
}

function escapeHTML(pStr)
{
	if (pStr == null) return '';
	return String(pStr).replace(/[&<>"']/g, (c) => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));
}

module.exports = PictViewLayout;
module.exports.default_configuration = _ViewConfiguration;
module.exports.formatDuration = formatDuration;
module.exports.escapeHTML = escapeHTML;
